module.exports = __webpack_public_path__ + "static/media/MentalHealth.57b8a2fd.svg";